"use client";
import { useRef } from "react";
import { createContext, ReactNode } from "react";

const AMPLITUDE_API_KEY = "f10f2a5a095445cab2e9b242373c8568";

export interface AmplitudeContextValue {
  trackAmplitudeEvent: (
    eventName: string,
    eventProperties?: Record<string, any>
  ) => void;
}

export const AmplitudeContext = createContext<AmplitudeContextValue>({
  trackAmplitudeEvent: () => {},
});

interface AmplitudeContextProviderProps {
  children?: ReactNode;
}

const AmplitudeContextProvider = ({
  children,
}: AmplitudeContextProviderProps) => {
  const amplitudeRef = useRef<any>(null);
  const isInitialized = useRef(false);

  const initAmplitude = async () => {
    if (isInitialized.current) return;

    const amplitude = await import("@amplitude/analytics-browser");
    amplitude.init(AMPLITUDE_API_KEY);
    amplitudeRef.current = amplitude;
    isInitialized.current = true;
  };

  const trackAmplitudeEvent = async (
    eventName: string,
    eventProperties?: Record<string, any>
  ) => {
    await initAmplitude();
    amplitudeRef.current?.track(eventName, eventProperties);
  };

  const value = { trackAmplitudeEvent };

  return (
    <AmplitudeContext.Provider value={value}>
      {children}
    </AmplitudeContext.Provider>
  );
};

export default AmplitudeContextProvider;
